import { render, staticRenderFns } from "./RegistroConfirm.vue?vue&type=template&id=1ffc2378&"
import script from "./RegistroConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistroConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports